import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddModalPrepaidAccount",
  tabindex: "-1",
  ref: "addPrepaidAccountModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-warning mt-10 p-10"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_16 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_21 = { class: "col-12 text-end mt-20" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "prepaidAccountForm",
            onSubmit: _ctx.addPrepaidAccount,
            "validation-schema": _ctx.prepaidAccountSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Acteur "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "acteur" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.acteurOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Sélectionner l'acteur",
                          disabled: _ctx.isUPDATE,
                          loading: _ctx.loadingacteurs,
                          canDeselect: false
                        }), {
                          option: _withCtx(({ option }) => [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'text-warning': option.hasActiveAccount })
                            }, _toDisplayString(option.label), 3)
                          ]),
                          _: 1
                        }, 16, ["options", "modelValue", "onUpdate:modelValue", "disabled", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "acteur",
                      class: "text-danger"
                    }),
                    (_ctx.selectedActeurHasAccount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "flaticon-warning me-2" }, null, -1)),
                          _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Attention :", -1)),
                          _createTextVNode(" Cet acteur possède déjà un compte prépayé actif (" + _toDisplayString(_ctx.selectedActeurAccountNumber) + "). Vous devez d'abord suspendre ou fermer ce compte avant d'en créer un nouveau. ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Devise "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "currencyCode" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.currencyOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la devise" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "currencyCode",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Statut "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "status" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.statusOptions,
                          searchable: false,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Statut",
                          disabled: !_ctx.isUPDATE
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "status",
                      class: "text-danger"
                    }),
                    (!_ctx.isUPDATE)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_15, " Le statut sera automatiquement \"Actif\" à la création "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!_ctx.isUPDATE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Solde initial ", -1)),
                        _createVNode(_component_Field, {
                          name: "initialBalance",
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "0.00"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "initialBalance",
                          class: "text-danger"
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted" }, "Solde de départ (optionnel, par défaut 0)", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Limite de crédit (découvert autorisé) ", -1)),
                    _createVNode(_component_Field, {
                      name: "creditLimit",
                      type: "number",
                      step: "0.01",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "0.00"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "creditLimit",
                      class: "text-danger"
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("small", { class: "text-muted" }, "Montant maximum de découvert autorisé", -1))
                  ])
                ]),
                (!_ctx.isUPDATE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "alert alert-info mt-20" }, [
                        _createElementVNode("i", { class: "flaticon-info me-2" }),
                        _createElementVNode("strong", null, "Information :"),
                        _createElementVNode("ul", { class: "mb-0 mt-10" }, [
                          _createElementVNode("li", null, "Le numéro de compte sera généré automatiquement (PP/YYYY/XXXXXX)"),
                          _createElementVNode("li", null, "Un acteur ne peut avoir qu'un seul compte prépayé actif à la fois"),
                          _createElementVNode("li", null, "Les acteurs avec un compte actif sont indiqués par ")
                        ])
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                    type: "submit",
                    disabled: _ctx.submitting || (_ctx.acteurOptions.length === 0 && !_ctx.isUPDATE)
                  }, _toDisplayString(_ctx.submitting ? 'Traitement...' : _ctx.btntext), 9, _hoisted_22)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetValue()))
        })
      ])
    ])
  ], 512))
}